<template>
  <div class="text-left" v-if="currentUser && accessibleUsers && accessibleUsers.length > 1">
    <a href="#" @click.prevent="open = !open">
      Switch Account <i class="fa" :class="{ 'fa-chevron-down': !open, 'fa-chevron-up': open }"></i>
    </a>

    <div class="border push-30 br-3 shadow-light bg-white position-abs z-999 push-10-t mh-300 overflow-y-scroll" v-if="open">
      <div v-for="u in accessibleUsers" @click.prevent="switchTo(u)" class="pad-20 hover-highlight" :class="{ 'hover-highlight-active': isCurrent(u), 'hover-pointer': !isCurrent(u) }" :key="u.id">
        <div v-if="!!u.parentID">
          <span class="font-w600">{{ u.parent.accountName }}</span>
          <br/>
          <span v-if="u.roleTitle == developerRole"><small>Developer</small></span>
          <span v-else><small>View as {{ u.parent.fullName }}</small></span>
        </div>

        <div v-else-if="!!u.advisorID">
          <span class="font-w600">{{ u.advisor.accountName }}</span>
          <br/>
          <span><small>{{ u.advisor.fullName }}'s Client</small></span>
        </div>

        <div v-else>
          <span class="font-w600">{{ u.accountName }}</span>
          <br/>
          <span v-if="u.accountOwner"><small>Account Owner</small></span>
          <span v-else><small>{{ u.roleTitle }}</small></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator'; 
import UserTypes from '../../../types/users';
import UserConstants from '../../../constants/users';

@Component
export default class Layout extends Vue {
  @Prop({ type: Object }) currentUser!: UserTypes.User;
  @Prop({ type: Array }) accessibleUsers!: Array<UserTypes.User>;

  developerRole = UserConstants.roles.DEVELOPER;
  open = false;

  switchTo(u: UserTypes.User) {
    if (this.isCurrent(u)) { return; }
    window.location.href = `/users/${u.id}/access`;
  }
  isCurrent(u: UserTypes.User): boolean {
    return this.currentUser.id == u.id;
  }
}
</script>
